import { combineReducers, applyMiddleware, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'

import sellNowReducer from './reducers/sellNowReducer'
import myAccountReducer from "./reducers/myAccountReducer";
import selfCheckInReducer from "./reducers/selfCheckInReducer";
import appReducer from "./reducers/appReducer";
import shopifyReducer from "./reducers/shopifyReducer";
import tradeInReducer from "./reducers/tradeInReducer";

export default function configureStoreProd(preloadedState) {
    const middlewares = [thunkMiddleware]
    const middlewareEnhancer = applyMiddleware(...middlewares)

    const reducers = combineReducers({
        sellNowReducer, myAccountReducer, selfCheckInReducer, appReducer, shopifyReducer, tradeInReducer
    })

    const store = createStore(reducers, preloadedState, middlewareEnhancer)

    return store
}